import { adaptedToGroupe, groupeToAdapted, groupesToAdapted } from "../../adapter/groupeAdapter";
import { HttpMethod, initFetch } from "../../utils/fetcher";

export const LOAD_SUCCESS_GROUPES = "LOAD_SUCCESS_GROUPES";
export const LOAD_FAIL_GROUPES = "LOAD_FAIL_GROUPES";
export const SAVE_SUCCESS_GROUPES = "SAVE_SUCCESS_GROUPES";
export const SAVE_FAIL_GROUPES = "SAVE_FAIL_GROUPES";
export const UPDATE_SUCCESS_GROUPES = "UPDATE_SUCCESS_GROUPES";
export const UPDATE_FAIL_GROUPES = "UPDATE_FAIL_GROUPES";
export const DELETE_SUCCESS_GROUPES = "DELETE_SUCCESS_GROUPES";
export const DELETE_FAIL_GROUPES = "DELETE_FAIL_GROUPES";

export function loadGroupes() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`groupes`, HttpMethod.GET);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.groupe);
          dispatch({
            type: LOAD_SUCCESS_GROUPES,
            payload: groupesToAdapted(res.groupe),
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: LOAD_FAIL_GROUPES,
            error: err,
          });
        });
    });
  };
}

export function saveGroupe(jsonData) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`groupes`, HttpMethod.POST);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToGroupe(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(groupeToAdapted(res.groupe));
          dispatch({
            type: SAVE_SUCCESS_GROUPES,
            payload: groupeToAdapted(res.groupe),
          });
        })
        .catch((err) =>
          dispatch({
            type: SAVE_FAIL_GROUPES,
            error: err,
          })
        );
    });
  };
}

export function updateGroupe(jsonData, id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`groupes/${id}`, HttpMethod.PUT);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToGroupe(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(groupeToAdapted(res.groupe));
          dispatch({
            type: UPDATE_SUCCESS_GROUPES,
            payload: groupeToAdapted(res.groupe),
          });
        })
        .catch((err) =>
          dispatch({
            type: UPDATE_FAIL_GROUPES,
            error: err,
          })
        );
    });
  };
}

export function deleteGroupe(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`groupes/${id}`, HttpMethod.DELETE);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(groupeToAdapted(res.groupe));
          dispatch({
            type: DELETE_SUCCESS_GROUPES,
            payload: groupeToAdapted(res.groupe),
            id: id,
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: DELETE_FAIL_GROUPES,
            error: err,
          });
        });
    });
  };
}
